<template>
  <div class="admin-reviews">
    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'admin-actions'}">Admin Actions</router-link>
          / <strong class="name">Reviews Importer</strong>
        </h1>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content admin-reviews">
          <div class="admin-reviews-form">
            <transition name="fade">
              <ImportReviewsForm
                v-if="!jobCompleted"
                v-model="job"
                :companies="companies"
                :websites="websites"
                :pages="pages"
                @submit="startJob"
                :errors="errors"
              />

              <div v-else>
                <h2>All Reviews Added!</h2>
                 <router-link
                  :to="{
                    name: 'list',
                    params: {
                      companyId: job.companyId,
                      siteId: job.siteId,
                      pageId: job.pageId,
                      listId: createdListId
                    }
                  }"
                  class="btn is-primary"
                >
                  View Reviews
                </router-link>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Reviews Importer</h1>
            <p>
              Create a <strong>Reviews</strong> widget on a selected page
              and prefill it with customer reviews.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>
  </div>
</template>

<script>
import ImportReviewsForm from '@/components/forms/ImportReviewsForm'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'

import page from '@/mixins/page'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'
import {readCompanySitePagesData} from '@/lib/pages'

import {createCompanySitePageListData} from '@/lib/lists'
import {createCompanySitePageListListItemData} from '@/lib/list_items'
import {readListTypesData} from '@/lib/list_types'

export default {
  name: 'admin-website',

  mixins: [page],

  data() {
    return {
      jobCompleted: false,
      job: {
        reviews: 'Jack McLaughlin|Here is a positive review\nBethany Rice|Here is another positive review'
      },
      errors: {},
      logs: ['Ready...'],
      title: 'Reviews Importer',
      companies: [],
      websites: [],
      pages: [],
      createdListId: '',
      page: {page: 1, page_size: 500}
    }
  },

  components: {
    ImportReviewsForm,
    PageHeader,
    PageSummary
  },

  computed: {
    reviewsType() {
      return this.listTypes.find((type) => type.name === 'reviews')
    }
  },

  methods: {
    getData() {
      readListTypesData().then(({data}) => {
        this.listTypes = data
      })

      readCompaniesData(this.page).then(({data}) => {
        data.forEach((company) => {
          this.companies.push(
            {
              key: company.name,
              value: company.id
            }
          )
        })
      })
    },

    getCompanySites() {
      readCompanySitesData(this.job.companyId, this.page).then(({data}) => {
        this.websites = []

        data.forEach((site) => {
          this.websites.push(
            {
              key: site.name,
              value: site.id
            }
          )
        })
      })
    },

    getCompanySitePages() {
      readCompanySitePagesData(this.job.companyId, this.job.siteId, this.page).then(({data}) => {
        this.pages = []

        data.forEach((page) => {
          this.pages.push(
            {
              key: page.name,
              value: page.id
            }
          )
        })
      })
    },

    startJob() {
      this.createPageReviews()
    },

    createPageReviews() {
      let list = {
        name: 'Reviews',
        list_type_id: this.reviewsType.id,
        weight: 10
      }

      createCompanySitePageListData(this.job.companyId, this.job.siteId, this.job.pageId, list)
        .then(({data}) => {
          let createdList = data
          let reviews = this.job.reviews.split('\n')
          let listItem
          this.createdListId = data.id

          this.logs.push(`Successfully created '${createdList.name}'`)

          for (let i = 0; i < reviews.length; i++) {
            let content = reviews[i].split('|')

            listItem = {
              key: content[0],
              value: `{"review": "<p>${content[1]}</p>", "author": "${content[0]}"}`,
              weight: i
            }

            this.createPageListListItem(createdList, listItem)
          }

          this.completeJob()
        })
        .catch(({response}) => {
          this.logs.push(response)
        })
    },

    createPageListListItem(createdList, listItem) {
      createCompanySitePageListListItemData(
        this.job.companyId,
        this.job.siteId,
        this.job.pageId,
        createdList.id,
        listItem
      )
        .then(({data}) => {
          let listItem = data
          this.logs.push(`Successfully created list item ${listItem.key}`)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    completeJob() {
      this.jobCompleted = true
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    'job.companyId'() {
      this.getCompanySites()
    },

    'job.siteId'() {
      this.getCompanySitePages()
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'

.admin-gallery
  .admin-gallery-form
    margin-bottom: 5px

  textarea
    height: 200px

  .logs
    display: none
    color: #fff
    border-radius: 3px
    padding: $gap-small
    min-width: 100%
    flex-basis: 30%
    overflow: auto
    border: 2px solid rgba(0, 0, 0, 0.2)

    @include themify($themes)
      background: themed('color-secondary')
</style>
